"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const countries_1 = require("../countries");
const utils_1 = require("@loadsure/utils");
const stateCodes_1 = require("../stateCodes");
const errors_1 = __importStar(require("../errors"));
class Address {
    constructor(address1, city, state, postal, country, address2) {
        var _a, _b;
        this.address1 = address1;
        this.city = city;
        this.postal = postal;
        this.address2 = address2;
        this.country = (_a = countries_1.getCountryCode(country)) !== null && _a !== void 0 ? _a : "";
        this.state = (_b = stateCodes_1.stateCodes.getCode(this.country, state)) !== null && _b !== void 0 ? _b : state;
    }
    static fromObj(data) {
        return new Address(data.address1, data.city, data.state, data.postal, data.country, data.address2);
    }
    static empty() {
        return new Address("", "", "", "", "", "");
    }
    equals(obj) {
        if (obj instanceof Address) {
            return (this.address1 === obj.address1 &&
                this.address2 === obj.address2 &&
                this.city === obj.city &&
                this.state === obj.state &&
                this.postal === obj.postal &&
                this.country === obj.country);
        }
        return false;
    }
    isEmpty() {
        return (!this.address1 &&
            !this.address2 &&
            !this.city &&
            !this.state &&
            !this.postal &&
            !this.country);
    }
    setFields(obj) {
        this.address1 = obj.address1;
        this.address2 = obj.address2;
        this.city = obj.city;
        this.state = obj.state;
        this.postal = obj.postal;
        this.country = obj.country;
    }
    static shortAddress(address = {}) {
        const parts = [
            address.address1,
            address.address2,
            address.city,
            address.state,
            address.postal,
            countries_1.getCountryCode(address.country)
        ];
        const shortAddress = parts.filter(utils_1.notEmpty).join(", ");
        return shortAddress === countries_1.getCountryCode(address.country) ? "" : shortAddress;
    }
    get shortAddress() {
        return Address.shortAddress(this);
    }
    isValid() {
        return (!!this.address1 &&
            !!this.city &&
            !!this.state &&
            !!this.postal &&
            !!this.country);
    }
    validate(path, postalRequired) {
        const errors = [];
        if (!this.address1) {
            errors.push(new errors_1.default(errors_1.eErrorCode.ADDRESS_ADDRESS1_NOT_SET, `${path}.address1`));
        }
        if (!this.city) {
            errors.push(new errors_1.default(errors_1.eErrorCode.ADDRESS_CITY_NOT_SET, `${path}.city`));
        }
        if (!this.state) {
            errors.push(new errors_1.default(errors_1.eErrorCode.ADDRESS_STATE_NOT_SET, `${path}.state`));
        }
        if (postalRequired && !this.postal) {
            errors.push(new errors_1.default(errors_1.eErrorCode.ADDRESS_POSTAL_NOT_SET, `${path}.postal`));
        }
        if (!this.country) {
            errors.push(new errors_1.default(errors_1.eErrorCode.ADDRESS_COUNTRY_NOT_SET, `${path}.country`));
        }
        return errors;
    }
}
exports.default = Address;
//# sourceMappingURL=address.class.js.map